import { render, staticRenderFns } from "./PreviewBuildings.vue?vue&type=template&id=25ed624b&"
import script from "./PreviewBuildings.vue?vue&type=script&lang=ts&"
export * from "./PreviewBuildings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports